define(["exports", "./pubsubhub"], function (_exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.done = _exports.name = void 0;
  // @ts-check

  /**
   * Module core/post-process
   *
   * Corresponds to respecConfig.postProcess and config.afterEnd.
   *  - postProcess: an array of functions that get called
   *      after processing finishes. This is not recommended and the feature is not
   *      tested. Use with care, if you know what you're doing. Chances are you really
   *      want to be using a new module with your own profile.
   *  - afterEnd: final thing that is called.
   */
  const name = "core/post-process";
  _exports.name = name;
  let doneResolver;
  const done = new Promise(resolve => {
    doneResolver = resolve;
  });
  _exports.done = done;
  (0, _pubsubhub.sub)("plugins-done", async config => {
    const result = [];

    if (Array.isArray(config.postProcess)) {
      const promises = config.postProcess.filter(f => {
        const isFunction = typeof f === "function";

        if (!isFunction) {
          (0, _pubsubhub.pub)("error", "Every item in `postProcess` must be a JS function.");
        }

        return isFunction;
      }).map(async f => {
        try {
          return await f(config, document);
        } catch (err) {
          (0, _pubsubhub.pub)("error", "Function ".concat(f.name, " threw an error during `postProcess`. See developer console."));
          console.error(err);
        }
      });
      const values = await Promise.all(promises);
      result.push(...values);
    }

    if (typeof config.afterEnd === "function") {
      result.push((await config.afterEnd(config, document)));
    }

    doneResolver(result);
  }, {
    once: true
  });
});
//# sourceMappingURL=post-process.js.map